import {gql} from "@irati/utils/gql"
import wellnessMediaAuthor from "./WellnessMediaAuthor"

const fragment = gql`
  fragment wellnessMediaArticle on WellnessMedia {
    uuid
    title
    type
    src
    thumbnail
    duration
    description
    categoryId
    liveVideoStartTime
    liveVideoEndTime
    category {
      uuid
      name
      mediaLabel
      svgData
    }
    provider {
      name
    }
    author {
      ...wellnessMediaAuthor
    }
    liveVideoStartTime
    liveVideoEndTime
    price
    rentalPeriod
    rentalPeriodUnit
  }
  ${wellnessMediaAuthor}
`

export const toString = fragment.loc.source.body

export default fragment
